<template>
  <div>
    <editable-map
      editable
      id="thePickerMap"
      ref="thePickerMap"
      :zoom.sync="currentZoom"
      :options="mapOptions"
      :center="center"
      :min-zoom="minZoom"
      :max-zoom="maxZoom"
      :bounds.sync="bounds"
      style="height: 500px; width: 100%"
      @ready="emitReady"
      @click="pickPlace($event.latlng.lat, $event.latlng.lng)"
    >
      <l-tile-layer
        v-for="tileProvider in tileProviders"
        :key="tileProvider.name"
        :name="tileProvider.name"
        :visible="tileProvider.visible"
        :url="tileProvider.url"
        :attribution="tileProvider.attribution"
        layer-type="base"
        :options="tileProvider.options"
        v-if="tileProvidersReady"
      />
      <l-control-layers
        :position="layersPosition"
        :collapsed="false"
        :sort-layers="true"
      />
      <l-control-zoom :position="zoomPosition" />
      <l-control-attribution
        :position="attributionPosition"
        prefix="Moova"
      />
      <l-control-scale position="bottomright" :imperial="imperial" />

      <editable-circle
        ref="circle"
        interactive
        :editable="circleEditable"
        :lat-lng="circleCenter"
        :radius="circleRadius"
        @editable:editing="updateEditedCircle($event)"
        v-if="circleCenter.length === 2"
        @click="circleEditable = !circleEditable"
      />
    </editable-map>
    <form @submit.prevent="emitPlacePicked" class="my-3">
      <div class="form-group col-sm-12">
        <b-button variant="primary" type="submit" :disabled="this.circleCenter.length === 0" v-translate>
          Confirm Area
        </b-button>
        <b-button variant="secondary" @click.prevent="emitCancel" v-translate>
          Cancel
        </b-button>
      </div>
    </form>
  </div>
</template>
<script>
import { latLng } from 'leaflet'
import AddressMixins from '@/mixins/address.mixin.js'
import {
  LMap,
  LTileLayer,
  LMarker,
  LPolyline,
  LLayerGroup,
  LTooltip,
  LPopup,
  LControlZoom,
  LControlAttribution,
  LControlScale,
  LControlLayers,
  LControl,
  LIcon
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import { EditableMap, EditablePolygon } from 'vue2-leaflet-editable'
import EditableCircle from '@/components/EditableCircle'
import LControlFullscreen from 'vue2-leaflet-fullscreen'

export default {
  name: 'CirclePicker',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPolyline,
    LLayerGroup,
    LTooltip,
    LPopup,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    LControlLayers,
    LControl,
    LIcon,
    EditableMap,
    EditablePolygon,
    EditableCircle,
    LControlFullscreen
  },
  data() {
    return {
      reference: '',
      icon: null,
      places: [],
      currentPlace: null,
      map: null,
      mapReady: false,
      center: [-34.6158036, -58.5035093],
      opacity: 1,
      mapOptions: {
        zoomControl: false,
        attributionControl: false,
        zoomSnap: true
      },
      currentZoom: this.zoom || 11,
      minZoom: 1,
      maxZoom: 18,
      zoomPosition: 'topleft',
      layersPosition: 'topright',
      attributionPosition: 'bottomright',
      imperial: false,
      markers: [],
      bounds: null,
      fitted: false,
      circleCenter: this.setCircleCenter,
      circleRadius: this.setCircleRadius,
      paths: [],
      circleEditable: true
    }
  },
  props: {
    geolocate: {
      type: Boolean,
      default: false
    },
    fitOnce: {
      type: Boolean,
      default: false
    },
    fitAlways: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Number,
      default: 11
    },
    centerMap: {
      type: Boolean,
      default: false
    },
    hasReference: {
      type: Boolean,
      default: false
    },
    setCircleCenter: {
      type: Array,
      default: []
    },
    setCircleRadius: {
      type: Number,
      default: 500
    }
  },
  mixins: [AddressMixins],
  created() {
    this.checkMapProviders()
  },
  mounted() {
    if (this.geolocate === true) {
      this.geolocateMap()
    }
  },
  methods: {
    geolocateMap() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = [position.coords.latitude, position.coords.longitude]
      })
    },
    pickPlace(lat, lng) {
      if (this.circleCenter.length === 0) {
        this.center = [lat, lng]
        this.circleCenter = [lat, lng]
      }
    },
    emitPlacePicked() {
      this.$emit('circle-picked', {
        lat: this.circleCenter[0],
        lng: this.circleCenter[1],
        radius: this.circleRadius
      })
    },
    emitCancel() {
      this.$emit('cancel')
    },
    emitReady() {
      this.map = this.$refs.thePickerMap.mapObject
      this.map.on('popupclose', () => this.emitCourier(null))
      this.mapReady = true
      this.$emit('ready', true)
      setTimeout(function () {
        this.map.invalidateSize()
        if (this.setCircleCenter.length === 2) {
          this.center = this.setCircleCenter
          let center = latLng(this.setCircleCenter[0], this.setCircleCenter[1])
          this.bounds = center.toBounds(this.circleRadius * 2)
        }
      }.bind(this), 100)
    },
    updateEditedCircle(e) {
      this.circleCenter = [e.layer._events.drag[0].ctx._resizeLatLng.__vertex.latlngs[0].lat, e.layer._events.drag[0].ctx._resizeLatLng.__vertex.latlngs[0].lng]
      this.circleRadius = e.layer._mRadius
    }
  }
}

</script>
